__turbopack_context__.v({
  "container": "styles-module__zcZzaa__container",
  "spinner": "styles-module__zcZzaa__spinner",
});
